// extracted by mini-css-extract-plugin
export default {"productItems":"Products_productItems__rb3Pk","category":"Products_category__C+QgR","grid":"Products_grid__8TM+O"};